export default __webpack_public_path__ + "static/media/potato-17.d6d2b5d3.png";